import { useEffect, useState } from "react"
import { CategoriaGasto, useCategorias_Gasto_Con_EliminadasQuery, useCategorias_Gasto_Sin_EliminadasQuery } from "src/gql/schema"
import { add } from "src/shared/helpers/calculator"
import { useProfile } from "src/shared/hooks/useProfile"

export function useGastosList({ categoryId, date = "", year = "", with_deleted_subcategories = true }: { categoryId?: string, date: string, year: string, with_deleted_subcategories: boolean }) {
    const { hotel_id } = useProfile()
    const { data } = useCategorias_Gasto_Con_EliminadasQuery({
        variables: {
            hotel_id,
            // MM-YYYY
            mes_y_anio: `${String(add(Number(date), 1)).padStart(2, "0")}-${year}`
        },
        skip: !with_deleted_subcategories
    })

    const { data: dataWithoutEliminadas } = useCategorias_Gasto_Sin_EliminadasQuery({
        variables: {
            hotel_id,
        },
        skip: with_deleted_subcategories
    })

    const [categoriaList, setCategoriaList] = useState<CategoriaGasto[]>([])
    const [subcategoriaList, setSubCategoriaList] = useState<any[]>([])

    useEffect(() => setCategoriaList((with_deleted_subcategories ? data?.categorias_gasto : dataWithoutEliminadas?.categorias_gasto) as CategoriaGasto[] || []), [data, dataWithoutEliminadas])

    useEffect(() => {
        setSubCategoriaList((categoriaList || [])?.filter(c => categoryId ? c.categoria_id === categoryId : true)?.flatMap(c => c.subcategorias_de_categoria))
    }, [categoriaList, categoryId])

    const handleSelectCategory = (categoriaId: string) => {
        if (!categoriaId.length) {
            setSubCategoriaList((categoriaList || [])?.flatMap(c => c.subcategorias_de_categoria))
            return
        }
        const find = categoriaList?.find((item) => item?.categoria_id === categoriaId)
        const filter = find?.subcategorias_de_categoria
            ? find?.subcategorias_de_categoria?.filter((item) => !item?.eliminado)
            : []

        setSubCategoriaList(filter.length ? filter : (categoriaList || [])?.flatMap(c => c.subcategorias_de_categoria))
    }

    return {
        categorias: categoriaList,
        selectedCategorias: categoriaList,
        selectedSubCategorias: subcategoriaList,
        handleSelectCategory,
    }
}
